import LazyComponent from '@v4/common/components/atoms/LazyComponent/LazyComponent';

export default LazyComponent;
